import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import InfoSection from "@quest_editor/components/InfoSection";

const CheckInstructionSection = ({
  checkerNote,
  receiptCheckDescription,
  checkerPhoneFile,
}: {
  checkerNote: string | null;
  receiptCheckDescription: string | null;
  checkerPhoneFile: string | null;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_detail.section.check_instruction")}
      rightContent={
        <SubActionButton
          size="small"
          component={Link}
          to="edit"
        >
          {t("quest_detail.button.edit")}
        </SubActionButton>
      }
      rows={[
        {
          label: t("quest_detail.field.check_instruction.checker_note"),
          children: (
            <Typography color="text.secondary">
              {checkerNote ?? ""}
            </Typography>
          ),
        },
        {
          label: t(
            "quest_detail.field.check_instruction.receipt_check_description",
          ),
          children: (
            <Typography color="text.secondary">
              {receiptCheckDescription ?? ""}
            </Typography>
          ),
        },
        {
          label: t("quest_detail.field.check_instruction.checker_phone_file"),
          children: (
            <Typography color="text.secondary">
              {checkerPhoneFile ?? ""}
            </Typography>
          ),
        },
      ]}
    />
  );
};

export default CheckInstructionSection;
